module.exports = __webpack_public_path__ + "static/img/02009A_1_V_20201120_LC.7af499e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02009A_1_V_20201120_LC.png
// module id = WPcp
// module chunks = 0